import { useState as c, useCallback as s, useEffect as i } from "react";
const p = e => {
  const [r, t] = c(0),
    [u, a] = c([]),
    S = s(o => {
      e && e.scrollTo(o);
    }, [e]),
    n = s(o => {
      a(o.scrollSnapList());
    }, []),
    l = s(o => {
      t(o.selectedScrollSnap());
    }, []);
  return i(() => {
    e && (n(e), l(e), e.on("reInit", n), e.on("reInit", l), e.on("select", l));
  }, [e, n, l]), {
    selectedIndex: r,
    scrollSnaps: u,
    onDotButtonClick: S
  };
};
export { p as useCarouselDotButton };